import { render, staticRenderFns } from "./YearPlan_0317.vue?vue&type=template&id=873caf88&scoped=true"
import script from "./YearPlan_0317.vue?vue&type=script&lang=js"
export * from "./YearPlan_0317.vue?vue&type=script&lang=js"
import style0 from "./YearPlan_0317.vue?vue&type=style&index=0&id=873caf88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873caf88",
  null
  
)

export default component.exports